import React from 'react';
import { IconButton } from '@mui/material';

/**
 * Creates a container with arrows that allows transferring between two boxes.
 * @param {boolean} leftToRightEnabled Enables or disables the left to right arrow.
 * @param {function} leftToRightCallback The callback to be executed when transferring from left to right.
 * @param {boolean} rightToLeftEnabled Enables or disables the right to left arrow.
 * @param rightToLeftCallback The callback to be executed when transferring from right to left.
 * @return {JSX.Element}
 * @constructor
 */
function TransferListArrows({ leftToRightEnabled, leftToRightCallback, rightToLeftEnabled, rightToLeftCallback }) {
    return (
        <div className="wcf-ui-transfer-list-arrows">
            <button onClick={() => leftToRightCallback()} disabled={!leftToRightEnabled}>
                <span className="icon stw-right-chevron"></span>
            </button>
            <button onClick={() => rightToLeftCallback()} disabled={!rightToLeftEnabled}>
                <span className="stw-left-chevron"></span>
            </button>
        </div>
    );
}

export default TransferListArrows;
